export class Area {
  constructor(public width: number, public height: number) {}
}
